module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 52
// module chunks = 0 1